import React from 'react';

export function DebitIcon() {
  return (
    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.666504 10.3333V3.66658C0.666504 1.82564 2.15889 0.333252 3.99984 0.333252H9.83317V1.99992H3.99984C3.07936 1.99992 2.33317 2.74611 2.33317 3.66658V10.3333C2.33317 11.2537 3.07936 11.9999 3.99984 11.9999H9.83317V13.6666H3.99984C2.15889 13.6666 0.666504 12.1742 0.666504 10.3333Z" fill="#111111" />
      <path d="M17.2282 2.83324H15.4435C15.2972 2.58022 15.0862 2.36925 14.8332 2.22288V0.438258C16.0045 0.73974 16.9267 1.6619 17.2282 2.83324Z" fill="#111111" />
      <path d="M14.8332 11.7769C15.0862 11.6306 15.2972 11.4196 15.4435 11.1666H17.2282C16.9267 12.3379 16.0045 13.2601 14.8332 13.5616V11.7769Z" fill="#111111" />
      <path d="M13.1665 0.333252H11.4998V1.99992H13.1665V0.333252Z" fill="#111111" />
      <path d="M17.3332 4.49992H15.6665V6.16658H17.3332V4.49992Z" fill="#111111" />
      <path d="M7.33317 5.33325H4.83317V6.99992H7.33317V5.33325Z" fill="#111111" />
      <path d="M15.6665 7.83325H17.3332V9.49992H15.6665V7.83325Z" fill="#111111" />
      <path d="M11.4998 11.9999H13.1665V13.6666H11.4998V11.9999Z" fill="#111111" />
    </svg>
  );
}
